module.exports = __webpack_public_path__ + "assets/images/animations/ministerioconsumo-animation.png?4b02b5f0";